<div [ngClass]="{ 'login-page': !isLogged }" role="main" aria-label="Login page">
    <div [ngClass]="{ 'loginWrapper': !isLogged }">
        <div [ngClass]="{ 'login-card fines-card': !isLogged }"  >
            <div class="filters" role="main" aria-label="Applications list page">
                <h2 [appTranslate]="'SEARCH_FOR_FINES'"></h2>
                <div class="app-list">
                    <div class="searchCard">

                        <div class="filter-field">
                            <label for="zone" [appTranslate]="'ZONE'"></label>
                            <input id="zone" name="zone" type="text" class="form-control"
                                [(ngModel)]="searchModel.ZoneName">
                            <div id="login-email-errors" class="errors error-messages" style="height: 16px;"><app-error
                                    *ngIf="errors" [errors]="errors" [ErrorKey]="'ZoneName'"
                                    class="error-feedback"></app-error>
                            </div>
                        </div>
                        <div class="filter-field">
                            <label for="registration" [appTranslate]="'REGISTRATION'"></label>
                            <input id="registration" name="registration" type="text" class="form-control"
                                [(ngModel)]="searchModel.PlateNumber"
                                (ngModelChange)="searchModel.PlateNumber = $event?.toUpperCase()">
                            <div id="login-email-errors" class="errors error-messages" style="height: 16px;"><app-error
                                    *ngIf="errors" [errors]="errors" [ErrorKey]="'PlateNumber'"
                                    class="error-feedback"></app-error>
                            </div>
                        </div>

                        <div class="filterBtns" style="    margin-bottom: 24px;">
                            <button type="button" class="round-btn clear" (click)="clearFilter()"
                                aria-label="Clear filters">
                                <img src="/assets/images/refresh.svg" alt="" aria-hidden="true">
                            </button>
                            <button type="button" class="round-btn search" (click)="getFines()"
                                aria-label="Search applications">
                                <img src="/assets/images/search-normal.svg" alt="" aria-hidden="true">
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <h4 [appTranslate]="'UNPAID_SURCHARGE_CARDS'"></h4>
            <table class="custom-table" *ngIf="totalUnpaidFines > 0">
                <thead>
                    <tr>
                        <th><span [appTranslate]="'FINE_NUMBER'"></span></th>
                        <th><span [appTranslate]="'ZONE'"></span></th>
                        <th><span [appTranslate]="'REGISTRATION'"></span></th>
                        <th><span [appTranslate]="'PRICE'"></span></th>
                        <th><span [appTranslate]="'REFERENCE'"></span></th>
                        <th><span [appTranslate]="'CREATED_DATE'"></span></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let unpaidFine of unpaidFines">
                        <td>{{unpaidFine.FineId}}</td>
                        <td>{{unpaidFine.AssetOwnerUniqueID}}</td>
                        <td>{{unpaidFine.CarNo}}</td>
                        <td>{{unpaidFine.AmountText}}</td>
                        <td>{{unpaidFine.BankReference}}</td>
                        <td>{{unpaidFine.ActivateTimeText}}</td>


                        <td style="    text-align: center;">
                            <button [appTranslate]="'PAY'" type="button" class="btn btn-primary"
                                (click)="pay(unpaidFine)" aria-label="Pay"></button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="no-data" *ngIf="totalUnpaidFines==0">
                <small [appTranslate]="'NO_DATA'"></small>
            </div>

            <h4 [appTranslate]="'PAID_SURCHARGE_CARDS'"></h4>
            <table class="custom-table" *ngIf="totalPaidFines > 0">
                <thead>
                    <tr>
                        <th><span [appTranslate]="'FINE_NUMBER'"></span></th>
                        <th><span [appTranslate]="'ZONE'"></span></th>
                        <th><span [appTranslate]="'REGISTRATION'"></span></th>
                        <th><span [appTranslate]="'PRICE'"></span></th>
                        <th><span [appTranslate]="'REFERENCE'"></span></th>
                        <th><span [appTranslate]="'CREATED_DATE'"></span></th>
                        <th><span [appTranslate]="'PAID_DATE'"></span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let paidFine of paidFines">
                        <td>{{paidFine.FineId}}</td>
                        <td>{{paidFine.ZoneName}}</td>
                        <td>{{paidFine.PlateNumber}}</td>
                        <td>{{paidFine.Amount| number:'1.2-2' }} MKD</td>
                        <td>{{paidFine.BankRefenreces}}</td>
                        <td>{{paidFine.Date | date: 'dd.MM.yyyy HH:mm'}}</td>
                        <td>{{paidFine.CasysResponseDate | date: 'dd.MM.yyyy HH:mm'}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="no-data" *ngIf="totalPaidFines==0">
                <small [appTranslate]="'NO_DATA'"></small>
            </div>
        </div>
    </div>
</div>